export default class BaseChannel {
  constructor(settings, dependencies) {
    this.id = settings.id
    this.params = settings.params

    this.widgetContainer = dependencies.widgetContainer

    this.setup()
  }

  setup() {}

  open() {}

  triggerPublicEvent(eventName, data) {
    if (this.widgetContainer !== null) {
      this.widgetContainer.triggerPublicEvent(eventName, data)
    }
  }
}
